import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import PropTypes from "prop-types";
import { makeGetIsRetiredSelector } from "~/store/selectors/selector.configOptions";

export const RequireActive = ({ children, redirectTo }) => {
  const getIsRetired = useMemo(() => {
    return makeGetIsRetiredSelector();
  }, []);
  const isAccountRetired = useSelector(getIsRetired);

  return !isAccountRetired ? children : <Navigate to={redirectTo} />;
};

RequireActive.propTypes = {
  redirectTo: PropTypes.string,
  children: PropTypes.any,
};

RequireActive.defaultProps = {
  redirectTo: "/retired",
};
